var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-2",attrs:{"justify":"start","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Bienvenue "+_vm._s(_vm.$session.get('person').firstname)+" ! 🎉")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }